var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVouchers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.24 16.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.24,6.09c-.47,0-.88-.02-1.28,0-1.34,.08-2.37,1.15-2.35,2.44,.02,1.32,1.04,2.33,2.4,2.38,.38,.01,.77,0,1.21,0,0,1.74,.03,3.42-.02,5.09-.02,.57-.47,.9-1.04,.97-.17,.02-.34,0-.52,0-7.01,0-14.02,0-21.03,0-.89,0-1.62-.72-1.62-1.62,0-1.46,0-2.92,0-4.46,.41,0,.78,.01,1.13,0,.94-.02,1.84-.52,2.25-1.37,.77-1.58-.38-3.31-1.97-3.44-.45-.04-.9,0-1.4,0C.02,4.34-.02,2.66,.04,.99,.05,.42,.5,.09,1.08,.01c.17-.02,.34,0,.52,0,7.01,0,14.02,0,21.03,0,.89,0,1.62,.72,1.62,1.62,0,1.46,0,2.92,0,4.47Zm-15.74,1.41v1.97c0,.11,.09,.2,.2,.2h1.95c.11,0,.2-.09,.2-.2v-1.97c0-.11-.09-.2-.2-.2h-1.95c-.11,0-.2,.09-.2,.2Zm.18-2.68h1.98c.11,0,.2-.09,.2-.2v-1.95c0-.11-.09-.2-.2-.2h-1.98c-.11,0-.2,.09-.2,.2v1.95c0,.11,.09,.2,.2,.2Zm-.19,7.53v1.99c0,.11,.09,.2,.2,.2h1.96c.11,0,.2-.09,.2-.2v-1.99c0-.11-.09-.2-.2-.2h-1.96c-.11,0-.2,.09-.2,.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVouchers);
export default __webpack_public_path__ + "static/media/vouchers.f6b5c4f3531bdf1525448f9194687f5b.svg";
export { ForwardRef as ReactComponent };